import { Box } from "@mui/material";
import { Color, DotLegalChip } from "@dotlegal/dotlegal-ui-components";
import React from "react";

export interface FrameworkTemplateStatusChipProps {
    isPublished: boolean;
}

function FrameworkTemplateStatusChip(props: FrameworkTemplateStatusChipProps) {
    return (
        <DotLegalChip
            variant={"outlined"}
            color={props.isPublished ? Color.greenCyan : Color.lavender}
            size={"small"}
            value={props.isPublished ? "Active" : "Draft"}
        />
    );
}

export default FrameworkTemplateStatusChip;
